import type { TStrikethroughData } from '@/features/strikethrough/types';
import type { TWithResponseHeaders } from '@/infra/types/api';
import type { TFetchPartsOptions } from '@/store/fetchableParts/types';

import checkResultForError from '@/features/apollo/checkResultForError';
import { strikethroughDataNull } from '@/features/strikethrough/slice';
import { FETCH_STRIKETHROUGH_DATA, type GQLStrikethroughApiAnswer } from '@/helpers/api/graphql';
import { query } from '@/helpers/api/graphql/apollo-server-only-instance';

export type TFetchStrikethroughArgs = { fetchOptions?: TFetchPartsOptions } & TWithResponseHeaders;

export const fetchStrikethrough = async ({
  fetchOptions,
  onResponseHeaders,
}: TFetchStrikethroughArgs): Promise<{ data: TStrikethroughData }> => {
  const result = await query<GQLStrikethroughApiAnswer>({
    context: { fetchOptions, onResponseHeaders },
    query: FETCH_STRIKETHROUGH_DATA,
  });
  const error = checkResultForError(result);
  if (error) throw error;
  const strikethroughData = result?.data?.lookup?.strikethroughData[0] as unknown as TStrikethroughData;
  // TODO: Unwrap result
  return { data: strikethroughData ?? strikethroughDataNull };
};
